<template>
  <header>
    <div class="wrap">
      <div id="hamburger" v-on:click="display_menu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <nav id="menu">
        <li></li>
        <li class="about-menu" v-on:click="display_menu">
          <router-link to="/">Home</router-link>
        </li>
        <li v-for="navlink in routes" v-bind:key="navlink.name" v-on:click="display_menu">
          <router-link :to="navlink.path" @click.native="displayNavbar">{{ navlink.name }}</router-link>
        </li>
        <li class="about-menu" v-on:click="display_menu">
          <router-link to="/credits">Credits</router-link>
        </li>
        <li class="about-menu" v-on:click="display_menu">
          <router-link to="/contact">Contact</router-link>
        </li>
        <li class="about-menu" v-on:click="display_menu">
          <router-link to="/privacy">Privacy</router-link>
        </li>
      </nav>
    </div>
  </header>
</template>

<script>

import {bus} from "@/main";

export default {
  name: "Nav",
  data() {
    return {
      navbarVisible: false,
      routes: [{
        name: 'Explore',
        path: '/explore'
      },
        {
          name: 'About',
          path: '/about'
        },
        {
          name: 'Contribute',
          path: '/contribute'
        }
      ],
      clickSound: [],
      clickPath: [
        '/audio/UI/click/UI_Explore.mp3',
        '/audio/UI/click/UI_About.mp3',
        '/audio/UI/click/UI_Contribute.mp3',
      ],
      hoverSound: null,
      hoverPath: [
        '/audio/UI/hover/UI_hover1.mp3',
        '/audio/UI/hover/UI_hover2.mp3',
        '/audio/UI/hover/UI_hover3.mp3',
        '/audio/UI/hover/UI_hover4.mp3',
      ],
      hoverPlaying: false,
    }
  },
  methods: {
    displayNavbar() {
      this.navbarVisible = !this.navbarVisible
    },
    display_menu: function () {

      // we want to close the cart when moving out of 3d or between 2d pages
      if (this.$route.name !== 'Explore')
        bus.$emit("closeCart")

      setTimeout(this.playNavClick.bind(this), 150)


      var body = document.getElementsByTagName("body")[0];
      (!body.classList.contains("display_menu")) ? body.classList.add("display_menu") : body.classList.remove("display_menu");
    },
    close_all_menu: function () {
      var lis = document.getElementById("menu").getElementsByTagName("li");
      Array.from(lis).forEach(function (e) {
        e.style.marginTop = 0;
      });
    },

    playRandomSound() {
      if (this.hoverPlaying) return;
      this.hoverPlaying = true
      let tempRange = Math.floor(Math.random() * this.hoverPath.length)
      this.hoverSound = new Audio()
      this.hoverSound.src = this.hoverPath[tempRange]
      this.hoverSound.play()
      setTimeout(this.renableAudio.bind(this), 1500);
    },

    renableAudio() {
      this.hoverPlaying = false
      this.hoverSound = null
    },

    playNavClick() {
      if (this.$route.name === 'Explore') {
        this.clickSound[0].play()
      } else if (this.$route.name === 'About') {
        this.clickSound[1].play()
      } else {
        this.clickSound[2].play()
      }
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  },
  mounted() {
    this.clickSound[0] = new Audio()
    this.clickSound[0].src = this.clickPath[0]
    this.clickSound[1] = new Audio()
    this.clickSound[1].src = this.clickPath[1]
    this.clickSound[2] = new Audio()
    this.clickSound[2].src = this.clickPath[2]

    document.querySelector('.wrap').addEventListener('mouseover', this.playRandomSound.bind(this))
  },

}
</script>

<style scoped>
ul {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}

.wrap {
  max-width: 1024px;
  min-width: 320px;
}

header {
  display: -webkit-box;
  display: flex;
  z-index: 98;
  padding: 1em .75em;
  position: fixed;
  top: 0;
  right: 0;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-transition: 0.33s;
  transition: 0.33s;
}

header .wrap {
  padding: 0 2%;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: end;
  align-items: flex-end;
  -webkit-box-pack: justify;
  justify-content: space-between;
}

header img {
  width: 100px;
}

header #menu {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

header #menu li {
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left: 20px;
  background: var(--white);
}

header #menu li.about-menu {
  display: none;
}

header #menu li a {
  color: var(--darkest);
  cursor: pointer;
  font-size: .9em;
  border: none;
  border: 1px solid var(--darkest);
  -webkit-transition: 0.15s;
  transition: 0.15s;
  text-decoration: none;
  padding: .35em 1em .5em 1em;
  background: var(--white);
}

header #menu li a:active,
header #menu li a.active {
  color: var(--white);
  background: var(--dark);
}

header #menu li a:hover {
  border-color: var(--dark);
  background-color: var(--dark);
  color: white;
}

header #menu li a:hover i {
  background-color: var(--pale);
}

header .drop_menu {
  position: absolute;
  display: block;
  top: 149%;
  -webkit-transform: scaleY(0);
  transform: scaleY(0);
  width: auto;
  -webkit-transform-origin: top;
  transform-origin: top;
  background-color: #ffffff;
  -webkit-transition: 0.25s;
  transition: 0.25s;
  padding-bottom: 10px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

header .drop_menu a {
  margin-left: 20px;
  display: block;
  -webkit-transition: 0.45s;
  transition: 0.45s;
  opacity: 0;
  margin-right: 20px;
  padding: 10px 0 0 0;
}

header .drop_menu.display {
  -webkit-transform: scaleY(1);
  transform: scaleY(1);
}

header .drop_menu.display a {
  opacity: 1;
}

header #hamburger {
  cursor: pointer;
  z-index: 5;
  position: absolute;
  right: 0;
  top: 1.5em;
  padding: 1em;
  display: none;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

header #hamburger span {
  height: 2px;
  margin-top: 5px;
  margin-bottom: 5px;
  background-color: var(--dark);
  display: block;
  -webkit-transition: 0.33s;
  transition: 0.33s;
}

header #hamburger span:nth-child(1) {
  width: 12px;
}

header #hamburger span:nth-child(2) {
  width: 24px;
}

header #hamburger span:nth-child(3) {
  width: 12px;
}

.display_menu header #hamburger span:nth-child(1) {
  -webkit-transform: rotate(45deg) translate(2px, 1px);
  transform: rotate(45deg) translate(2px, 1px);
}

.display_menu header #hamburger span:nth-child(2) {
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.display_menu header #hamburger span:nth-child(3) {
  -webkit-transform: rotate(45deg) translate(6px, -9px);
  transform: rotate(45deg) translate(6px, -9px);
}

@media screen and (max-width: 1060px) {
  body {
    padding-top: 70px;
  }

  header {
    width: 100%;
    padding: 0;
  }

  header .wrap {
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    padding: 0;
    width: 100%;
  }

  header #hamburger {
    display: block;
  }

  header #menu {
    width: 100%;
    display: block;
    height: 0;
    -webkit-transform-origin: 50% 0;
    transform-origin: 50% 0;
    -webkit-transition: 0.33s ease;
    transition: 0.33s ease;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
  }

  /* .display_menu header #menu {
      height: calc(100vh - 64px);
  } */
  .display_menu header #menu li {
    height: calc((100vh - 113px) / 8);
    border-bottom: 1px solid #DAD9D7;
    -webkit-transition: 0.25s ease;
    transition: 0.25s ease;
    opacity: 1;
    display: block;
  }

  .display_menu header #menu li:first-of-type {
    height: 3.5em;
  }

  header #menu li {
    height: 0;
    opacity: 0;
    margin-left: 0;
    -webkit-transition: 0.25s ease;
    transition: 0.25s ease;
  }

  header #menu li.about-menu {
    display: block;
  }

  header #menu li a {
    left: 0;
    line-height: calc((100vh - 113px) / 8);
    padding: 0 1em;
    border: none;
    height: 100%;
    width: 100%;
    display: block;
  }

  header #menu li a:hover {
    color: #ffffff;
    background-color: var(--pale);
  }

  header #menu li a:hover i {
    background-color: #ffffff;
  }

  header #menu li i {
    position: absolute;
    right: 20px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    background-color: #3E3A37;
  }

  header .drop_menu {
    top: calc((100vh - 113px) / 8);
    box-shadow: none;
    left: 0;
    padding-bottom: 0;
    width: 100%;
  }

  header .drop_menu a {
    width: 100%;
    padding: 0 !important;
    padding-left: 40px !important;
    margin: 0;
    border-bottom: 1px solid #DAD9D7 !important;
  }
}

@media screen and (max-width: 1060px) and (max-height: 500px) {
  .display_menu header {
    max-height: 100vh;
    overflow-y: scroll;
  }

  .display_menu header #menu li {
    height: calc((100vh - 113px) / 4);
  }

  .display_menu header #menu li:first-of-type {
    height: 3.5em;
  }

  header #menu li a {
    line-height: calc((100vh - 113px) / 4);
  }

  header .drop_menu {
    top: calc((100vh - 113px) / 4);
  }
}
</style>
